import React from 'react';
import PropTypes from 'prop-types';
import TrendingStoriesOverviewWizard from './components/TrendingStoriesOverviewWizard';
import * as actions from './TrendingStoriesOverview.slice';
import { connect } from 'react-redux';

const mapStateToProps = (
  (state) => ({
    wizardStore: state.TrendingStoriesOverview || {},
    isOpen: state.TrendingStoriesOverview.isOpen,
    timezone: state.AppUser.user.timezone,
    isTwitterRestricted: state.TrendingStoriesOverview.isTwitterRestricted
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

const TrendingStoriesOverview = ({
  isOpen,
  wizardStore,
  handleClose,
  timezone = 'EST',
  loadTweets,
  setCurrentViewIndex,
  isTwitterRestricted
}) => (
  <TrendingStoriesOverviewWizard
    isOpen={isOpen}
    wizardStore={wizardStore}
    handleClose={handleClose}
    timezone={timezone}
    onFetchTweets={loadTweets}
    handleViewChange={setCurrentViewIndex}
    isTwitterRestricted={isTwitterRestricted}
  />
);

TrendingStoriesOverview.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  wizardStore: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  timezone: PropTypes.string,
  loadTweets: PropTypes.func.isRequired,
  setCurrentViewIndex: PropTypes.func.isRequired,
  isTwitterRestricted: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, actions, mergeProps)(TrendingStoriesOverview);
